import { render, staticRenderFns } from "./SurgeryDepositInvoices.vue?vue&type=template&id=5052489c"
import script from "./SurgeryDepositInvoices.vue?vue&type=script&lang=js"
export * from "./SurgeryDepositInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports